<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="'修改密码'"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
            <el-form-item label="旧密码" prop="oldPwd">
                <el-input show-password v-model="item.oldPwd" placeholder="请输入旧密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
                <el-input show-password v-model="item.newPwd" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input show-password v-model="item.checkPass" placeholder="请输确认密码"></el-input>
            </el-form-item>
			<el-form-item>
                    <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                        >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
             </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            var validatePass2 = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.item.newPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                item: {
                },
                isLoad: false,
                id: this.$route.query.id,
                token: localStorage.token,
                options: [],
				dialogVisible: false,
                rules: {
                    oldPwd: [
                        {required: true, message: '旧密码不能为空', trigger: 'blur'}
                    ],
                    newPwd: [
                        {required: true, message: '新密码不能为空', trigger: 'blur'}
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                }
            }
        },

        methods: {
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },

            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false
                this.axios.put('/admin/user/pwd', this.item).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '修改成功'
                    });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            }
        }
    }
</script>
<style scoped>
</style>·
